export const UNITLOCATION = {
	WAREHOUSE: {
		id: 0,
		intl: 'warehouse',
	},
};
